// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__DShVy","carousel":"overlay_carousel__4c2+0","content":"overlay_content__0oiR-","logo":"overlay_logo__+qXzW"};